import type { GridLayout } from '../components/DocumentPage/useGridLayout';

export function isLayoutOneOf(layouts: GridLayout[], layout: GridLayout): boolean {
    return layouts.includes(layout);
}
